import navBarHomepage from '../modules/navbar-homepage';
import signIn from '../modules/sign_in';
import fbAuth from '../modules/fb_auth';
import twitterAuth from '../modules/twitter_auth';

let signinController = () => {
    navBarHomepage.on();
    signIn.on();
    fbAuth.on();
    twitterAuth.on();
};

export default signinController;
